import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Label } from '@blueprint/ui';

export const DropdownWrapper = styled.div(
    () => css`
        display: flex;
    `
);

export const LeftWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-right: ${spacing['8px']};
        width: 50%;
    `
);

export const RightWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-left: ${spacing['8px']};
        width: 50%;
    `
);

export const FiltersLabel = styled(Label)(
    ({ theme: { spacing, colors } }) => css`
        padding: 0 0 ${spacing['8px']} 0;
        margin-top: ${spacing['24px']};
        display: block;
        margin-bottom: 0;
        color: ${colors['text-body']};
    `
);
